// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cdcc3462","239":"2a267c32","453":"60974f4d","455":"fb58ae88"}[chunkId] + ".chunk.js";
};